import cn from "@/hooks/class-names";
import React from "react";

export default function CustomText({ text, className, onClick, type }) {
  const splitText = (type && text.split("::")) || [text];

  return (
    <label
      className={cn("laptop:text-[15px] laptop-large:text-[18px]", className)}
      onClick={() => {
        onClick && onClick();
      }}
    >
      {(type &&
        splitText.map((part, index) => (
          <span key={index} className="block">
            {part.trim()}
          </span>
        ))) || <span>{text}</span>}
    </label>
  );
}
